import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "resource-themes-page"
}

import { computed } from "vue";
import {
  CmsDocument,
  CmsResourceTheme,
  CmsResourceThemesPage,
} from "../../services/cms/cms-type-definitions";
import ResourceThemesList from "../../components/cms/resource-themes-list.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'resource-themes-page',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props;

const doc = computed(() => props.doc as CmsResourceThemesPage);

return (_ctx: any,_cache: any) => {
  return (doc.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doc.value.data.body, (slice, index) => {
          return (_openBlock(), _createBlock(ResourceThemesList, {
            key: index,
            doc: slice.primary.tile_carousel_embed_link
          }, null, 8, ["doc"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})